$(document).ready(function(){

$('.multiple-items').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1
});
  
  
  $('.colorlist li').click(function(){
    
    var imag = $(this).attr('data-img');
    
    console.log(imag);
    
    $('.multiple-items .slick-slide').each(function(){
      
      
      var slick_image = $(this).find('.image_get').attr('data-image'),
          index = $(this).attr('data-slick-index');
      
      
      if(slick_image == imag){
       
        $('.multiple-items').slick('slickGoTo', index);
       
      }
      
      
    });
    
  });
  
			
});

$.getJSON(window.Shopify.routes.root + 'products/9ct-gold-oval-sapphire-and-diamond-cluster-ring-7pts-d6708n.js', 
function(product) {
  alert('The title of this product is ' + product.title);
} );